
import { useState, useEffect } from 'react';
import { useContentManager } from '../../hooks/useContentManager';

export default function FeaturedProject() {
  const { sliders, loading } = useContentManager();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Admin panelden slider verilerini al - tüm slider'ları kullan
  const projectSliders = sliders.length > 0 ? sliders : [];
  
  // Eğer admin panelden veri yoksa varsayılan verileri kullan
  const projects = projectSliders.length > 0 ? projectSliders.map(slider => ({
    title: slider.title,
    subtitle: slider.subtitle,
    image: slider.image_url || 'https://readdy.ai/api/search-image?query=Luxury%20modern%20skyscraper%20building%20with%20sleek%20glass%20facade%20and%20golden%20lighting%20at%20sunset%2C%20architectural%20photography%2C%20premium%20real%20estate%20development%2C%20Dubai%20skyline%20background%2C%20cinematic%20lighting%2C%20ultra-high%20resolution&width=1920&height=1080&seq=1&orientation=landscape',
    link: '#',
    buttonText: 'DISCOVER THE COLLECTION'
  })) : [
    {
      title: 'Golden Tower Residences',
      subtitle: 'Luxury Living',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20skyscraper%20building%20with%20sleek%20glass%20facade%20and%20golden%20lighting%20at%20sunset%2C%20architectural%20photography%2C%20premium%20real%20estate%20development%2C%20Dubai%20skyline%20background%2C%20cinematic%20lighting%2C%20ultra-high%20resolution&width=1920&height=1080&seq=1&orientation=landscape',
      link: '#',
      buttonText: 'DISCOVER THE COLLECTION'
    },
    {
      title: 'Golden Tower Premium',
      subtitle: 'Exclusive Collection',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20luxury%20residential%20tower%20with%20modern%20design%20elements%2C%20metallic%20silver%20and%20black%20facade%2C%20premium%20architecture%2C%20Dubai%20cityscape%2C%20golden%20hour%20lighting%2C%20professional%20architectural%20photography&width=1920&height=1080&seq=2&orientation=landscape',
      link: '#',
      buttonText: 'DISCOVER THE COLLECTION'
    },
    {
      title: 'Golden Tower Elite',
      subtitle: 'Luxury Residences',
      image: 'https://readdy.ai/api/search-image?query=Ultra-luxury%20diamond-inspired%20skyscraper%20with%20crystalline%20facade%20design%2C%20premium%20residential%20tower%2C%20Dubai%20downtown%2C%20dramatic%20lighting%2C%20architectural%20masterpiece%20photography&width=1920&height=1080&seq=3&orientation=landscape',
      link: '#',
      buttonText: 'DISCOVER THE COLLECTION'
    }
  ];

  useEffect(() => {
    if (projects.length === 0) return;
    
    const interval = setInterval(() => {
      handleNext();
    }, 6000);
    return () => clearInterval(interval);
  }, [projects.length]);

  const handleNext = () => {
    if (isTransitioning || projects.length === 0) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % projects.length);
      setIsTransitioning(false);
    }, 300);
  };

  const handlePrev = () => {
    if (isTransitioning || projects.length === 0) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + projects.length) % projects.length);
      setIsTransitioning(false);
    }, 300);
  };

  const goToSlide = (index: number) => {
    if (isTransitioning || index === currentIndex || projects.length === 0) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 300);
  };

  // Loading durumunda
  if (loading) {
    return (
      <section className="relative h-screen w-full overflow-hidden bg-black flex items-center justify-center">
        <div className="text-white text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p className="text-lg">Slider yükleniyor...</p>
        </div>
      </section>
    );
  }

  if (projects.length === 0) {
    return (
      <section className="relative h-screen w-full overflow-hidden bg-black flex items-center justify-center">
        <div className="text-white text-center">
          <i className="ri-slideshow-line text-6xl mb-4 opacity-50"></i>
          <h2 className="text-2xl font-light mb-2">Henüz Slayt Eklenmemiş</h2>
          <p className="text-gray-400">Admin panelden slayt ekleyebilirsiniz.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* Main Slider */}
      <div className="relative h-full w-full">
        {projects.map((project, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
              index === currentIndex 
                ? 'opacity-100 scale-100 z-10' 
                : index === (currentIndex - 1 + projects.length) % projects.length
                ? 'opacity-0 scale-110 z-5'
                : 'opacity-0 scale-95 z-0'
            }`}
          >
            <div className="absolute inset-0">
              <img
                src={project.image}
                alt={project.title}
                className={`w-full h-full object-cover transition-transform duration-[8000ms] ease-out ${
                  index === currentIndex ? 'scale-105' : 'scale-100'
                }`}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://readdy.ai/api/search-image?query=Luxury%20modern%20skyscraper%20building%20with%20sleek%20glass%20facade%20and%20golden%20lighting%20at%20sunset%2C%20architectural%20photography%2C%20premium%20real%20estate%20development%2C%20Dubai%20skyline%20background%2C%20cinematic%20lighting%2C%20ultra-high%20resolution&width=1920&height=1080&seq=1&orientation=landscape';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/30"></div>
            </div>
          </div>
        ))}

        {/* Content Overlay */}
        <div className="relative h-full flex flex-col items-center justify-center text-center px-8 z-20">
          <div className={`transition-all duration-700 ${isTransitioning ? 'opacity-0 transform translate-y-8' : 'opacity-100 transform translate-y-0'}`}>
            <h2 className="text-white text-5xl md:text-7xl lg:text-8xl mb-8 font-light tracking-wider leading-tight">
              <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300">
                {projects[currentIndex].title.split(' ')[0]}
              </span>
              <br />
              <span className="text-4xl md:text-5xl lg:text-6xl font-extralight">
                {projects[currentIndex].title.split(' ').slice(1).join(' ')}
              </span>
              <br />
              <span className="text-2xl md:text-3xl lg:text-4xl text-gray-300 font-light tracking-widest">
                {projects[currentIndex].subtitle}
              </span>
            </h2>
            <div className="flex flex-col items-center gap-6"></div>
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={handlePrev}
        className="absolute left-8 top-1/2 -translate-y-1/2 z-30 group"
        aria-label="Previous"
      >
        <div className="w-16 h-16 border border-white/30 hover:border-white flex items-center justify-center transition-all duration-300 hover:bg-white/10">
          <i className="ri-arrow-left-line text-white text-2xl group-hover:transform group-hover:-translate-x-1 transition-transform duration-300"></i>
        </div>
      </button>
      <button
        onClick={handleNext}
        className="absolute right-8 top-1/2 -translate-y-1/2 z-30 group"
        aria-label="Next"
      >
        <div className="w-16 h-16 border border-white/30 hover:border-white flex items-center justify-center transition-all duration-300 hover:bg-white/10">
          <i className="ri-arrow-right-line text-white text-2xl group-hover:transform group-hover:translate-x-1 transition-transform duration-300"></i>
        </div>
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-30">
        <div className="flex gap-4">
          {projects.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`relative h-1 transition-all duration-500 cursor-pointer group ${
                index === currentIndex 
                  ? 'w-16 bg-white' 
                  : 'w-8 bg-white/40 hover:bg-white/70'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            >
              {index === currentIndex && (
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent animate-pulse"></div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Project Counter */}
      <div className="absolute bottom-12 right-8 z-30 text-white">
        <div className="flex items-center gap-4 text-sm tracking-widest">
          <span className="text-2xl font-light">
            {String(currentIndex + 1).padStart(2, '0')}
          </span>
          <div className="w-12 h-px bg-white/50"></div>
          <span className="text-white/60">
            {String(projects.length).padStart(2, '0')}
          </span>
        </div>
      </div>

      {/* Thumbnail Preview */}
      <div className="absolute bottom-12 left-8 z-30">
        <div className="flex gap-3">
          {projects.map((project, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`relative w-20 h-12 overflow-hidden transition-all duration-500 cursor-pointer ${
                index === currentIndex 
                  ? 'opacity-100 scale-110 border-2 border-white' 
                  : 'opacity-60 hover:opacity-80 border border-white/30'
              }`}
              aria-label={`Preview ${project.title}`}
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://readdy.ai/api/search-image?query=Luxury%20modern%20skyscraper%20building%20with%20sleek%20glass%20facade%20and%20golden%20lighting%20at%20sunset%2C%20architectural%20photography%2C%20premium%20real%20estate%20development%2C%20Dubai%20skyline%20background%2C%20cinematic%20lighting%2C%20ultra-high%20resolution&width=1920&height=1080&seq=1&orientation=landscape';
                }}
              />
              {index === currentIndex && (
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              )}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
